<template>
    <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M20.5 42V30.1L10.2 36.05L6.70001 30L17 24L6.70001 18.05L10.2 12L20.5 17.95V6H27.5V17.95L37.8 12L41.3 18.05L31 24L41.3 30L37.8 36.05L27.5 30.1V42H20.5Z" fill="inherit"/></svg>
</template>